document.addEventListener('DOMContentLoaded', () => {
  const variants = window.ProductVariants || [];
  const idInput = document.querySelector('[data-variant-input]');
  const galleryEl = document.getElementById('ProductGallery');
  const colorPos = Number(galleryEl?.getAttribute('data-color-pos') || 0);
  const ssrColor = (galleryEl?.getAttribute('data-current-color') || '').trim();

  function formatMoney(centsRaw) {
    const locale = window.shopLocale || 'en-US';
    const currency = window.shopCurrency || 'JPY';

    const isJPY = currency === 'JPY';

    const formatOptions = {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: isJPY ? 0 : 2,
      maximumFractionDigits: isJPY ? 0 : 2,
      currencyDisplay: 'symbol',
    };

    const cents = Number(centsRaw);
    if (!Number.isFinite(cents) || cents <= 0) return '';

    const amount = isJPY ? Math.round(cents / 100) : cents / 100;
    if (amount <= 0) return '';

    return amount.toLocaleString(locale, formatOptions);
  }

  function updatePrice(variantId) {
    const priceEl = document.querySelector('[data-product-price]');
    if (!priceEl) return;

    if (!variantId) {
      const defaultPrice = priceEl.dataset.defaultPrice || priceEl.textContent;
      priceEl.textContent = defaultPrice;
      return;
    }

    const variant = variants.find((v) => String(v.id) === String(variantId));
    if (!variant || !variant.price) return;

    const formattedPrice = formatMoney(variant.price);
    if (formattedPrice) {
      priceEl.textContent = formattedPrice;
    }
  }

  function updateURLWithState(variantId) {
    const url = new URL(window.location.href);
    if (variantId) {
      url.searchParams.set('variant', variantId);
      url.searchParams.delete('option1');
      url.searchParams.delete('color');
      url.searchParams.delete('colour');
    } else {
      url.searchParams.delete('variant');
      if (selected[1]) {
        url.searchParams.set('option1', selected[1]);
      } else {
        url.searchParams.delete('option1');
      }
    }
    url.hash = '';
    history.replaceState(null, '', url);
  }

  const selected = { 1: null, 2: null };

  const group1 = document.querySelector(
    '.option-group[data-option-position="1"]'
  );
  const group2 = document.querySelector(
    '.option-group[data-option-position="2"]'
  );
  let option1Buttons = group1
    ? Array.from(group1.querySelectorAll('.variant-option'))
    : [];
  let option2Buttons = group2
    ? Array.from(group2.querySelectorAll('.variant-option'))
    : [];

  function updateOption1Availability() {
    if (!group1) return;

    option1Buttons.forEach((btn) => {
      const val = btn.dataset.optionValue;
      const inStock = variants.some((v) => v.option1 === val && v.available);

      if (inStock) {
        btn.classList.remove('is-soldout');
        btn.removeAttribute('aria-disabled');
        btn.style.pointerEvents = '';
      } else {
        btn.classList.add('is-soldout');
        btn.removeAttribute('aria-disabled');
        btn.style.pointerEvents = '';
      }
    });
  }

  function updateOption2Availability() {
    if (!group2) return;

    option2Buttons.forEach((btn) => {
      const val = btn.dataset.optionValue;

      const inStock = variants.some(
        (v) =>
          v.available &&
          v.option2 === val &&
          (selected[1] ? v.option1 === selected[1] : true)
      );

      if (inStock) {
        btn.classList.remove('is-soldout');
        btn.removeAttribute('aria-disabled');
        btn.style.pointerEvents = '';
      } else {
        btn.classList.add('is-soldout');
        btn.removeAttribute('aria-disabled');
        btn.style.pointerEvents = '';
      }
    });
  }

  function getVariantFromURL() {
    try {
      const id = new URL(window.location.href).searchParams.get('variant');
      if (!id) return null;
      return variants.find((v) => String(v.id) === String(id)) || null;
    } catch (_) {
      return null;
    }
  }

  function getOption1FromURL() {
    try {
      const url = new URL(window.location.href);
      return (
        url.searchParams.get('option1') ||
        url.searchParams.get('color') ||
        url.searchParams.get('colour') ||
        null
      );
    } catch (_) {
      return null;
    }
  }

  (function initDefaultVariant() {
    if (!variants.length) return;

    const priceEl = document.querySelector('[data-product-price]');
    if (priceEl && !priceEl.dataset.defaultPrice) {
      priceEl.dataset.defaultPrice = priceEl.textContent;
    }

    const fromVariant = getVariantFromURL();
    const fromOpt1 = getOption1FromURL();
    const firstAvailable = variants.find((v) => v.available);

    if (fromVariant) {
      selected[1] = fromVariant.option1 || null;
      selected[2] = fromVariant.option2 || null;
      if (idInput) idInput.value = fromVariant.id || '';
      updateURLWithState(fromVariant.id);
      updatePrice(fromVariant.id);
    } else {
      if (fromOpt1) {
        selected[1] = fromOpt1;
        selected[2] = null;
      } else if (ssrColor) {
        if (colorPos === 2) {
          selected[2] = ssrColor;
          selected[1] = selected[1] || null;
        } else {
          selected[1] = ssrColor;
          selected[2] = null;
        }
      } else if (firstAvailable) {
        selected[1] = firstAvailable.option1 || null;
        selected[2] = firstAvailable.option2 || null;
      }

      const preselect = (() => {
        if (selected[1] || selected[2]) {
          return variants.find(
            (v) =>
              (selected[1] ? v.option1 === selected[1] : true) &&
              (selected[2] ? v.option2 === selected[2] : true) &&
              v.available
          );
        }
        return variants.find((v) => v.available) || null;
      })();

      const preselectId = preselect ? preselect.id : '';
      if (idInput) idInput.value = preselectId;
      updateURLWithState(preselectId);
      updatePrice(preselectId);
    }

    const btn1 = selected[1]
      ? document.querySelector(
          `.variant-option[data-option-position="1"][data-option-value="${selected[1]}"]`
        )
      : null;
    if (btn1) btn1.classList.add('is-selected');
    const btn2 = selected[2]
      ? document.querySelector(
          `.variant-option[data-option-position="2"][data-option-value="${selected[2]}"]`
        )
      : null;
    if (btn2) btn2.classList.add('is-selected');
  })();

  updateOption1Availability();
  updateOption2Availability();

  const form =
    document.querySelector('form[action*="/cart/add"]') ||
    document.getElementById('add-to-cart-form');
  if (form) {
    form.addEventListener('click', (e) => {
      const group = e.target.closest('.option-group');
      if (!group) return;
      const btn = e.target.closest('.variant-option');
      if (!btn) return;
      e.preventDefault();

      const pos = Number(btn.dataset.optionPosition);

      const buttons = pos === 1 ? option1Buttons : option2Buttons;
      buttons.forEach((el) => el.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      const value = btn.dataset.optionValue;
      selected[pos] = value;

      if (pos === 1) updateOption2Availability();

      const match = variants.find(
        (v) =>
          (selected[1] ? v.option1 === selected[1] : true) &&
          (selected[2] ? v.option2 === selected[2] : true)
      );
      const variantId = match ? match.id : '';
      idInput.value = variantId;
      updateURLWithState(variantId);
      updatePrice(variantId);
    });
  }
});
